import {
  type ElementRegistry,
  PageHeading,
  PageText,
  PageImage,
  PageBulletList,
  PageNumberedList,
  PageTodoList,
  PageActionItemView,
  PageJobCollectionView,
  PageQuote,
  PageCallout,
  PageCard,
  PageDivider,
  PageCode,
  PageTable,
  PageToggle,
  PageEntityView,
  PageLinkView,
  PageVideoView,
  PageFileView,
  PageAudioView,
  PageLocationView,
} from '@eaco/forms-ui-web';
import { formsAppElementRegistry } from './formsAppElementRegistry';

/**
 * The public form registry plus the page-document block renderers (from the
 * shared engine), used to render a page read-only in the document portal.
 */
export const pageElementRegistry: ElementRegistry = {
  ...formsAppElementRegistry,
  'page-heading': PageHeading,
  'page-heading-1': PageHeading,
  'page-heading-2': PageHeading,
  'page-heading-3': PageHeading,
  'page-heading-4': PageHeading,
  'page-text': PageText,
  'page-image': PageImage,
  'page-bullet-list': PageBulletList,
  'page-numbered-list': PageNumberedList,
  'page-todo-list': PageTodoList,
  // By name only: everything else about an action item lives on the record,
  // which a reader outside Eaco cannot see.
  'page-action-item': PageActionItemView,
  // Live job data never leaves Eaco — the reader gets a marker, not the board.
  'page-job-board': PageJobCollectionView,
  'page-job-list': PageJobCollectionView,
  'page-quote': PageQuote,
  'page-callout': PageCallout,
  'page-card': PageCard,
  'page-divider': PageDivider,
  'page-code': PageCode,
  'page-table': PageTable,
  'page-toggle': PageToggle,
  'page-video': PageVideoView,
  'page-file': PageFileView,
  'page-audio': PageAudioView,
  'page-location': PageLocationView,
  'page-link': PageLinkView,
  'page-entity': PageEntityView,
  'page-entity-job': PageEntityView,
  'page-entity-property': PageEntityView,
  'page-entity-asset': PageEntityView,
  'page-entity-contact': PageEntityView,
  'page-entity-project': PageEntityView,
} as ElementRegistry;
